var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"feedback-message",class:{
						'text-danger': _vm.error,
						'text-success': _vm.success,
						'visible': _vm.error || _vm.success,
						'not-visible': !_vm.error && !_vm.success
					}},[_vm._v("\n\t "+_vm._s(_vm.error || _vm.success)+"\n\t ")])}
var staticRenderFns = []

export { render, staticRenderFns }